export const submitResEnum = {
    success: 0,
    invalidForm: 1,
    submitFailed: 2,
}


// WEBPACK FOOTER //
// ./src/logic/buildStore/index.js